"use client";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { CacheKeys } from "../../constants/CacheKeys";
import { VsaTableColumnDefinition } from "../../constants/DataGridColumns";
import { useGetActivityFields } from "../../hooks/useActivities";
import { useGetDocumentFields } from "../../hooks/useTools";
import { ApiEndpoints } from "../../models/ApiEndpoints";
import { DocumentGridViewItem } from "../../models/DocumentGridViewItem";
import {
  getDocumentGridColumnsFromColumnOrder,
  mapDocumentGridItemIds,
} from "../../services/DocumentGridViewService";
import { PaginatedList } from "../list/PaginatedList";

const ArchivedDocumentList = () => {
  const { t } = useTranslation();

  const { data: documentViewDefinition, isLoading: documentFieldsLoading } =
    useGetDocumentFields();

  const {
    data: activityViewDefinition,
    isLoading: activityViewDefinitionLoading,
  } = useGetActivityFields();

  const columns = useMemo<
    VsaTableColumnDefinition<DocumentGridViewItem>[]
  >(() => {
    if (
      documentFieldsLoading ||
      !documentViewDefinition ||
      activityViewDefinitionLoading ||
      !activityViewDefinition
    ) {
      return [];
    }

    return getDocumentGridColumnsFromColumnOrder(
      documentViewDefinition.standardFields,
      documentViewDefinition.fields,
      activityViewDefinition.fields,
      documentViewDefinition.publishedFieldOrder
    );
  }, [
    documentViewDefinition,
    documentFieldsLoading,
    activityViewDefinition,
    activityViewDefinitionLoading,
  ]);

  return (
    <PaginatedList<DocumentGridViewItem>
      apiEndpoint={ApiEndpoints.DocumentGridViewArchived}
      columns={columns}
      defaultSortAscending={false}
      defaultSortColumnName={"modified"}
      searchPlaceholder={t("searchTool")}
      postQueryTransformation={mapDocumentGridItemIds}
      cacheKey={CacheKeys.Document.DocumentArchivedList}
      filtersEndpoint={ApiEndpoints.ToolDocumentFilters}
      storageKey="documents:archived"
      libraryFilterScope={{ listType: "document" }}
    />
  );
};

export default ArchivedDocumentList;
